import axios, { AxiosResponse } from "axios";

import {
  EHttpStatusCode,
  IHttpClient,
  THttpRequest,
  THttpResponse,
} from "../../../data/protocols/http";
import { AccessDeniedError, UnexpectedError } from "../../../domain/errors";
import { UnauthorizedError } from "../../../domain/errors/unauthorized-error";

export class AxiosHttpClient implements IHttpClient {
  async request(data: THttpRequest): Promise<THttpResponse> {
    let axiosResponse: AxiosResponse;

    try {
      axiosResponse = await axios.request({
        url: data.url,
        baseURL: data.baseUrl,
        params: data.params,
        method: data.method,
        data: data.body,
        headers: data.headers,
        responseType: data.responseType
      });
    } catch (error) {
      axiosResponse = (error as any).response;
    }

    switch (axiosResponse.status) {
      case EHttpStatusCode.ok:
      case EHttpStatusCode.created:
      case EHttpStatusCode.noContent:
        return {
          statusCode: axiosResponse.status,
          body: axiosResponse.data,
        };

      case EHttpStatusCode.forbidden:
        throw new AccessDeniedError();

      case EHttpStatusCode.unauthorized:
        throw new UnauthorizedError();

      default:
        const messageError = axiosResponse.data.message;
        throw new UnexpectedError(messageError);
    }
  }
}
